import React from 'react'
import PropTypes from 'prop-types'

import { Text, Wrapper } from 'Components/UI'

import { PROJECT_STATS } from 'Constants/Projects/projectStats'

import { Container, StatPlate, StatsGrid } from './styles'

function Stats({ projectId }) {
  const entry = PROJECT_STATS.find(item => item.projectId === projectId)

  if (!entry) return null

  return (
    <Container>
      <Wrapper alignItems="flex-start" flexDirection="column">
        <Text as="h2" legacyTitle lineHeight={1} mb={4}>
          Results in Numbers
        </Text>

        <StatsGrid>
          {entry.stats.map(stat => (
            <StatPlate key={stat.label}>
              <Text as="strong" fontSize={[24, 32]} medium>
                {stat.value}
              </Text>

              <Text body16 mt={1} semiLight>
                {stat.label}
              </Text>
            </StatPlate>
          ))}
        </StatsGrid>

        <Text as="p" body16 mt={4} semiLight>
          {entry.claim}
        </Text>
      </Wrapper>
    </Container>
  )
}

Stats.defaultProps = {
  projectId: '',
}

Stats.propTypes = {
  projectId: PropTypes.string,
}

export default Stats
